import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

import translationEN from './translationEN.json';
import translationRU from './translationRU.json';
import translationDE from './translationDE.json';
import translationES from './translationES.json';
import translationZH from './translationZH.json';

// Ключ языка. Раньше их было два: i18n читал 'oliLng' (наследие другого
// проекта, куда никто не писал), а переключатель писал в 'lang' — из-за этого
// выбранный язык не переживал перезагрузку. Теперь ключ один, а старое
// значение переносится, чтобы у текущих пользователей ничего не слетело.
export const LANG_KEY = 'tcLng';

const langMigrate = () => {
    try {
        if (localStorage.getItem(LANG_KEY)) {
            return;
        }
        const old = localStorage.getItem('lang') || localStorage.getItem('oliLng');
        if (old) {
            localStorage.setItem(LANG_KEY, old);
        }
    } catch (e) {
        // приватный режим — просто работаем без сохранённого языка
    }
};

langMigrate();

const lsLng = (()=>{
    try {
        return localStorage.getItem(LANG_KEY);
    } catch (e) {
        return null;
    }
})();

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    ru: {
        translation: translationRU
    },
    de: {
        translation: translationDE
    },
    es: {
        translation: translationES
    },
    zh: {
        translation: translationZH
    }
};

i18n
    .use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: lsLng ? lsLng : "en",

        // Без этого непереведённый ключ показывается как есть, а ключи у нас
        // русские: на de/es/zh половина страницы уходила в русский текст.
        // Теперь недостающее подхватывается из английского.
        fallbackLng: "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
